import { render, staticRenderFns } from "./TaxRemittanceModal.vue?vue&type=template&id=c2effada&scoped=true"
import script from "./TaxRemittanceModal.vue?vue&type=script&lang=js"
export * from "./TaxRemittanceModal.vue?vue&type=script&lang=js"
import style0 from "./TaxRemittanceModal.vue?vue&type=style&index=0&id=c2effada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2effada",
  null
  
)

export default component.exports